import { render, staticRenderFns } from "./others.vue?vue&type=template&id=65ace2b5&scoped=true&"
import script from "./others.vue?vue&type=script&lang=js&"
export * from "./others.vue?vue&type=script&lang=js&"
import style0 from "./others.vue?vue&type=style&index=0&id=65ace2b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ace2b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ace2b5')) {
      api.createRecord('65ace2b5', component.options)
    } else {
      api.reload('65ace2b5', component.options)
    }
    module.hot.accept("./others.vue?vue&type=template&id=65ace2b5&scoped=true&", function () {
      api.rerender('65ace2b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/me/others.vue"
export default component.exports